import { create } from 'zustand';
import type { MeerwerkType } from '@/api/meerwerken';

/**
 * A request to open the installer's meerwerk create form, preset to a type.
 * Lets a section elsewhere on the page (the interventie photo section's
 * "Uren melden") open the ONE existing form in MeerwerkenSection instead of
 * carrying a second copy of it. `nonce` makes a repeat tap a new request.
 */
interface MeerwerkFormState {
  request: { type: MeerwerkType; nonce: number } | null;
  open: (type: MeerwerkType) => void;
}

export const useMeerwerkFormStore = create<MeerwerkFormState>((set) => ({
  request: null,
  open: (type) => set((s) => ({ request: { type, nonce: (s.request?.nonce ?? 0) + 1 } })),
}));
